<template>
  <destroy
    :question="sub18n.question"
    :submit="sub18n.submit"
    icon="trash-alt"
    method="post"
    :url="url"
    @destroyed="destroyed"
  />
</template>

<script>
import _Destroy from "./_Destroy.vue";
export default {
  components: { destroy: _Destroy },
  props: ["project", "i18n"],
  computed: {
    sub18n() {
      return this.i18n.tab.discard;
    },
    url() {
      return this.$store.state.dashboard.projects.routes.discard.replace(
        ":id",
        this.project.id
      );
    },
  },
  methods: {
    destroyed() {
      this.$store.dispatch("dashboard/getPaginator");
      if (this.$route.name === "project.discard") {
        this.$router.push({
          name: "welcome",
          params: {
            type: this.$route.params.type,
            locale: this.$route.params.locale,
          },
        });
      }
    },
  },
};
</script>
